import React, { useContext } from "react";

// Global state
import { StateContext } from "../../AppStateContext";

// Material UI stuff
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import SpeedIcon from "@material-ui/icons/Speed";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

const IconContent = ({ handleClick, moduleName }) => {
  // Consuming state
  const state = useContext(StateContext);

  const StyledListItem = withStyles({
    root: {
      fontFamily: "Alegreya Sans, sans-serif",
      fontSize: "20px",
      color: state.theme === "dark" ? "#fa0171" : "#ffffff",
      textTransform: "uppercase",
    },
  })(ListItem);
  return (
    <StyledListItem
      button
      onClick={handleClick}
      id="wcsModuleIcon"
      style={{ display: state.clientId === "wcs" ? "flex" : "none" }}
    >
      <ListItemIcon
        style={{ color: state.theme === "dark" ? "#fa0171" : "#ffffff" }}
      >
        {!state.isSidebarOpen ? (
          <Tooltip title="WCS Module" placement="right">
            <SpeedIcon />
          </Tooltip>
        ) : (
          <SpeedIcon />
        )}
      </ListItemIcon>
      {moduleName}
    </StyledListItem>
  );
};

export default IconContent;
